import { FeatureConfiguration } from "..";
import { reducer } from "./reducers";

export * from "./reducers";
export * from "./selectors";

export default function (config: FeatureConfiguration) {
    config.reducers.banners = reducer;
}
